import type { ContactPreferencesSiteSettings } from '../../contactPreferences.types.ts';

const CONTACT_PREFERENCES: ContactPreferencesSiteSettings = {
  availableChannels: ['email', 'sms', 'phone'],
  channelIcons: {
    email: 'Email',
    sms: 'Mobile',
    phone: 'Phone',
  },
  channelTrackingNames: {
    email: 'Email',
    sms: 'SMS',
    phone: 'Mobile',
  },
};

export { CONTACT_PREFERENCES };
